<template>
    <CFormSelect
        :model-value="cSelectFormatValue"
        :feedback-invalid="invalidFeedback"
        :invalid="invalid"
        @update:modelValue="updateValue"
    >
        <option
            v-for="option in optionsObject"
            :key="option.label"
            :value="option.value !== null ? option.value : ''"
            :selected="modelValue === option.value"
            :hidden="option.hidden"
        >
            {{ option.label }}
        </option>
    </CFormSelect>
</template>

<script>
import { CFormSelect } from '@coreui/vue-pro'
import _ from 'lodash'

export default {
    name: 'DSelect',
    components: { CFormSelect },
    props: {
        isValid: {
            type: [Boolean, Function],
            default: null
        },
        invalidFeedback: {
            type: String,
            default: null
        },
        options: {
            default: null,
            type: Array
        },
        placeholder: {
            type: String,
            default: null
        },
        modelValue: {
            default: null,
            type: [String, Number]
        }
    },
    emits: ['update:modelValue', 'update:value', 'change'],
    computed: {
        cSelectFormatValue () {
            return this.modelValue === null ? null : String(this.modelValue)
        },
        optionsObject () {
            const options = _.cloneDeep(this.options)

            if (options[0]?.value) {
                return [{ label: '', value: null, hidden: true }, ...options]
            }

            return options
        },
        invalid () {
            return this.isValid === null ? (this.invalidFeedback !== null) : !this.isValid
        }
    },
    mounted () {
        if (this.modelValue === null && this.options[0] !== undefined) {
            this.$emit('update:modelValue', this.options[0].value !== null ? String(this.options[0].value) : null)
        }
    },
    methods: {
        updateValue (event) {
            this.$emit('update:modelValue', event)
            this.$emit('update:value', event)
            this.$emit('change')
        }
    }
}
</script>
